import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

function Signup() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { signup } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();

        if (password !== confirmPassword) {
            return setError(t('auth_passwords_mismatch'));
        }

        try {
            setError('');
            setLoading(true);
            await signup(email, password, 'user');
            navigate('/');
        } catch (err) {
            setError(t('auth_failed_create_account') + err.message);
        }
        setLoading(false);
    }

    return (
        <div className="page-section">
            <div className="auth-container">
                <h2 className="section-title">{t('auth_signup_title')}</h2>

                {error && <div className="error-banner">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="email">{t('auth_email')}</label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">{t('auth_password')}</label>
                        <input
                            type="password"
                            id="password"
                            className="form-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength="6"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmPassword">{t('auth_confirm_password')}</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            className="form-input"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn-primary-modern"
                        disabled={loading}
                    >
                        {loading ? t('auth_creating_account') : t('auth_signup_title')}
                    </button>
                </form>

                <p className="auth-link">
                    {t('auth_already_have_account')} <Link to="/login">{t('auth_login_link')}</Link>
                </p>
            </div>
        </div>
    );
}

export default Signup;
